var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appGrey rounded-lg pa-4"},[_c('app-text',[_vm._v(_vm._s(_vm.teamNotes ? _vm.teamNotes : 'There are no team notes to view.'))]),_c('v-divider',{staticClass:"mt-4"}),_c('app-btn',{staticClass:"mt-4",attrs:{"block":true,"label":"Close"},nativeOn:{"click":function($event){return _vm.closeDialog.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }